import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Box } from '@mui/material';

const deleteWidth = 34;

export default observer(function EditableTable({
  children,
}: {
  children: React.ReactNode;
}) {
  const [tdWidth, setTdWidth] = useState(0);

  return (
    <Box
      ref={(el: null | HTMLTableElement) => {
        if (el) {
          setTdWidth((el.offsetWidth - deleteWidth) / 3);
        }
      }}
      sx={{
        table: {
          display: 'table',
          borderCollapse: 'collapse',
          width: 1,
          th: {
            textAlign: 'start',
          },
          td: {
            'border': 1,
            'borderColor': 'text.secondary',
            'width': tdWidth,

            '&.deleteRowTd': {
              width: deleteWidth,
              border: 'none',
              bgcolor: 'background.default',
              svg: {
                opacity: 0,
                transition: 'opacity 100ms linear',
              },
            },
          },
          tr: {
            'transition': 'background-color 100ms linear',

            '&:hover:not(:first-of-type)': {
              'cursor': 'pointer',
              'bgcolor': 'customBackgrounds.hoverEffect',
              '& .deleteRowTd': {
                svg: {
                  opacity: 1,
                },
              },
            },
          },
        },
      }}
    >
      <table>
        <tbody>{children}</tbody>
      </table>
    </Box>
  );
});
